<div class="v3-overview">
  <app-v3-news-overview (navigate)="navigateNews.emit()"></app-v3-news-overview>
  <app-v3-earnings-overview (navigate)="navigateEarnings.emit()"></app-v3-earnings-overview>
  <app-v3-earnings-calendar (navigate)="navigateEarnings.emit()"></app-v3-earnings-calendar>
  <app-v3-analysts-overview
    [currentPrice]="currentPrice"
    (navigate)="navigateAnalysts.emit()"
  ></app-v3-analysts-overview>
  <app-v3-scores-overview (navigate)="navigate.emit($event)"></app-v3-scores-overview>
  <app-v3-competitor-overview
    [livePrices]="livePrices"
    (navigate)="navigateCompetitor.emit()"
    (navigateToInstrument)="navigateToInstrument.emit($event)"
  ></app-v3-competitor-overview>
</div>
